import { render } from "./SortDropdown.vue?vue&type=template&id=fdb56678"
import script from "./SortDropdown.vue?vue&type=script&lang=js"
export * from "./SortDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__